import getAlreadyRendered from './getalreadyrendered.js';
import forEach from '../../_helpers/foreach.js';
// this function gets called when array is sorted (via sort, orderBy or reverse)
export default function processSort(_ref) {
  var self = _ref.self,
    selfDef = _ref.selfDef,
    container = _ref.container;
  // just re-insert rendered nodes in new order
  forEach(self, function (item) {
    if (item && typeof item === 'object') {
      var node = getAlreadyRendered({
        item: item,
        selfDef: selfDef
      });
      if (node) {
        container.appendChild(node);
      }
    }
  });
}